/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pages': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M22.75 91.93a3.02 3.02 0 01-3.02 3.02l-11.71-.004A3.018 3.018 0 015 91.93V80.215a3.02 3.02 0 013.02-3.02h11.714a3.02 3.02 0 013.02 3.02zM95 65.809a8.672 8.672 0 01-8.672 8.672l-52.383-.004a8.672 8.672 0 01-8.672-8.672V13.723a8.672 8.672 0 018.672-8.672h52.383A8.672 8.672 0 0195 13.723zM84.348 17.735a2.028 2.028 0 00-2.027-2.027H37.954a2.028 2.028 0 00-2.028 2.027v44.066c0 1.117.907 2.027 2.028 2.027H82.32a2.028 2.028 0 002.027-2.027z"/>'
  }
})
